import { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const HLSPlayer = ({ src, sx, controls, method }) => {
  const videoRef = useRef();

  useEffect(() => {
    if (videoRef.current) {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(videoRef.current);
        return () => hls.destroy();
      } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        videoRef.current.src = src;
      }
    }
  }, [src]);

  const handleClick = (src) => {
    method?.(src); // pass click event to parent
  };

  return (
    <video
      onClick={() => handleClick(src)}
      ref={videoRef}
      controls={controls}
      autoPlay
      style={sx}
    />
  );
};

export default HLSPlayer;